import React, { forwardRef } from 'react';
import { MenuTrigger as CommonMenuTrigger } from '../../../common/ui/menu/trigger/main.tsx';
import type { MenuTriggerProps } from '../../../common/ui/menu/trigger/types.tsx';
import { MenuTrigger as CustomizedMenuTrigger } from './main.tsx';

export const MenuTrigger = forwardRef<HTMLElement, MenuTriggerProps>(
	(props: MenuTriggerProps, ref) => {
		if (!__SERVER__) {
			return <CustomizedMenuTrigger {...props} ref={ref} />;
		}

		return <CommonMenuTrigger {...props} ref={ref} />;
	},
);
